import { render, staticRenderFns } from "./CustomerListAddNew.vue?vue&type=template&id=56d1f51c"
import script from "./CustomerListAddNew.vue?vue&type=script&lang=js"
export * from "./CustomerListAddNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports